import './infoBox.css';
import { ICarinha } from './carinhas';

interface InfoBoxProps {
  carinha: ICarinha;
}

const InfoBox: React.FC<InfoBoxProps> = ({ carinha }) => {
  return (
    <div className="info-box-container">
      <div className="info-box" key={carinha.key}>
        {carinha.description}
      </div>
    </div>
  );
}

export default InfoBox;
